import { useCallback } from "react";

export function useDownload() {
  const download = useCallback(
    (data: BlobPart, fileName: string, mimeType = "application/json") => {
      const blob = new Blob(
        [typeof data === "string" ? data : JSON.stringify(data, null, 2)],
        { type: mimeType }
      );
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    []
  );

  return { download };
}
